import { useEffect, useState } from 'react'
import { authAPI } from '../services/api'

/**
 * The starting-fee rule every fee slider shares (the Fee Calculator and a
 * creator's record): the reader's saved fee if signed in and they have one,
 * else 0%, the gross record: nothing a user sees assumes a fee (decided
 * 2026-10-09). ``fee`` is null until that is known, so nothing is
 * fetched at a fee the reader never chose; ``saved`` is undefined while the
 * saved fee loads and null when there is none.
 */
const useStartingFee = (signedIn: boolean) => {
  const [saved, setSaved] = useState<number | null | undefined>(signedIn ? undefined : null)
  const [fee, setFee] = useState<number | null>(signedIn ? null : 0)

  useEffect(() => {
    if (!signedIn) {
      setSaved(null)
      setFee((current) => current ?? 0)
      return
    }
    let active = true
    authAPI
      .getMyFee()
      .then((data) => {
        if (!active) return
        setSaved(data.fee_pct_per_side)
        setFee((current) => current ?? data.fee_pct_per_side ?? 0)
      })
      .catch((error) => {
        console.error('Saved fee failed to load:', error)
        if (!active) return
        setSaved(null)
        setFee((current) => current ?? 0)
      })
    return () => {
      active = false
    }
  }, [signedIn])

  return { saved, setSaved, fee, setFee }
}

export default useStartingFee
